<template>
  <v-list-item v-if="!notification.readAt" @click="executeTextAction">
    <v-list-item-title>
      {{ actions.markAsRead }}
    </v-list-item-title>
  </v-list-item>
  <v-list-item v-else @click="executeTextAction">
    <v-list-item-title>
      {{ actions.markAsUnread }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "NotificationMenuList",

  props: {
    notification: {
      type: Object
    },
    actions: {
      type: Object
    },
    allRead: {
      type: Object
    }
  },
  methods: {
    /**
     * emits the notification to be executed in notificationsMenu component
     */
    executeTextAction() {
      this.$emit("executeTextAction", null, this.notification);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Management/Notifications/_Molecules/NotificationMenuList.vue